export default "__VITE_ASSET__Bk_9KwH___"